import { render } from "./NavbarMenu.vue?vue&type=template&id=067e28a3"
import script from "./NavbarMenu.vue?vue&type=script&lang=js"
export * from "./NavbarMenu.vue?vue&type=script&lang=js"

import "./NavbarMenu.vue?vue&type=style&index=0&id=067e28a3&lang=css"

import exportComponent from "D:\\projects\\mitool\\MITOOL\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__